import cx from 'classnames';
import { FunctionComponent } from 'react';
import { NavLink } from 'react-router';
import SubNavigation from '../navigation/SubNavigation';
import { AssetStatus } from './assetConstants';
import { isDraft, isUnpublished } from './assetHelpers';
import { useAssets } from './assetService';
import { AssetListItem } from './models/AssetListItem';

const AssetMenu: FunctionComponent = () => {
    const { assets, isLoading } = useAssets();

    return (
        <SubNavigation heading="Resurser">
            <div className="submenu__content">{renderContent(assets, isLoading)}</div>
            <div className="submenu__footer">
                <NavLink to="create" className="btn btn-primary">
                    Lägg till resurs
                </NavLink>
            </div>
        </SubNavigation>
    );
};

export default AssetMenu;

const renderContent = (assets: AssetListItem[] | undefined, isLoading: boolean) => {
    if (isLoading) {
        return (
            <div className="submenu__placeholder">
                <div>Laddar...</div>
            </div>
        );
    }

    if (!assets || assets.length === 0) {
        return (
            <div className="submenu__placeholder">
                <div>Ni har ännu inte lagt upp några resurser.</div>
            </div>
        );
    }

    const orderedList = orderByStatusAndName(assets);

    return (
        <div className="submenu__links">
            {orderedList.map((x) => (
                <NavLink key={x.assetId} to={x.assetId} className={getClassNames(x.status)}>
                    {x.name}
                </NavLink>
            ))}
        </div>
    );
};

const getClassNames = (assetStatus: AssetStatus): string | undefined => {
    return cx(['submenu__link', { 'submenu__link--draft': isDraft(assetStatus) }, { 'submenu__link--unpublished': isUnpublished(assetStatus) }]);
};

const orderByStatusAndName = (assets: AssetListItem[]) => {
    const sortedAssets = assets.sort((a, b) => a.name.localeCompare(b.name));
    const publishedAssets = sortedAssets.filter((x) => x.status === AssetStatus.Published);
    const unpublishedAssets = assets.filter((x) => x.status !== AssetStatus.Published);
    return publishedAssets.concat(unpublishedAssets);
};
